'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _values = require('./values');

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _prep2.default)({
    name: 'toArray',
    all: function all() {
        return function (item) {
            return [].concat(_toConsumableArray((0, _values2.default)()(item)));
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/toArray.js
// module id = 272
// module chunks = 35783957827783